import React, { useEffect } from 'react';
import { HeaderBanner, PostcodeConfirmation } from 'ctm-components';
import styled from 'styled-components';
import { pageContext } from 'ctm-util-functions';
import { useSelector } from 'react-redux';
import { getBrand } from 'ctm-app/client/store/selectors';

const PostCodeWrapper = styled.div`
    margin-top: -10rem;
    display: flex;
    width: 100%;
    padding-right: 1.2rem;
    padding-left: 1.2rem;
    align-items: center;
    justify-content: center;
    max-width: 75rem;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 1rem;
`;

const VerifyPage = () => {
    const elProps = {
        properties: {
            image: {
                alt: 'Compare The Market Australia Logo',
                src: '/evt/assets/brand/ctm/meerkat.png',
                title: 'Compare The Market Australia'
            },
            html: {
                tag: 'p',
                content: 'To help us verify that this is your quote, please enter the postcode you <br> gave us when you last quoted.',
                attributes: {
                    fontSize: '1.6rem',
                    fontWeight: '500',
                    lineHeight: '170%',
                    xsFontSize: '1.3rem',
                    marginLeft: '2.4rem',
                    marginRight: '2.4rem'
                }
            },
            layout: 'column',
            backgroundColor: '#001464',
            fontColor: '#FFFFFF',
            title: 'Confirm your postcode',
            topMarginDesktop: '5.0rem',
            topMarginMobile: '0rem',
            bottomMarginDesktop: '15rem',
            bottomMarginMobile: '13rem'
        }
    };

    // it is sufficient to only check if any reload exists, as the verify page is one
    // of the entry points to the car journey.
    // Any reloads that exist at this point will be of for the verify page
    const verifyPageWasReloaded = window.performance
        .getEntriesByType('navigation')
        .map((nav) => nav.type)
        .includes('reload');

    const browserHistory = pageContext.getProps().browserHistory;

    const brandCode = useSelector((state) => getBrand(state));

    // 11 MRE is very much still CTM branded, until this is resolved, we shall redirect to start of journey
    if (brandCode === 'islt') {
        browserHistory.push('/car-insurance/journey/prefill_check');
    }

    useEffect(() => {
        if (verifyPageWasReloaded) {
            if (confirm('Changes that you made may not be saved.')) {
                browserHistory.push('/car-insurance/journey/start');
            }
        }
    }, [verifyPageWasReloaded]);

    return (
        brandCode !== 'islt' && (
            <div>
                <HeaderBanner {...elProps} />
                <PostCodeWrapper>
                    <PostcodeConfirmation />
                </PostCodeWrapper>
            </div>
        )
    );
};

export { VerifyPage };
